import { RepresentationType } from 'shared/enums/RepresentationType';
import {
  IAddRepresentativeFormFields,
  IAgenciesAttributes,
  IAgenciesDivisionAttributes,
} from 'shared/interfaces/IRepresentatives';
import * as yup from 'yup';

// Data model
export const createProfileValidationSchema = yup.object().shape({
  representation_type: yup.mixed<RepresentationType>().oneOf(Object.values(RepresentationType)).required(),
  country: yup.string().required(),
  note: yup.string(),
  agency_id: yup.string(),
  access_code: yup.string(),
  confirmed_agreement: yup.boolean().default(false),
  profile_type: yup.string().required(),
  division_ids: yup.array().of(
    yup.object().shape({
      id: yup.string().required('ID is required'),
      name: yup.string().required('Name is required'),
    }),
  ),
});

export type KeyOfAddRepresentativesForm = keyof IAddRepresentativeFormFields;
export type SetFieldValueValueProps = Partial<IAgenciesAttributes | IAgenciesDivisionAttributes[] | string>;
export type OptionalValuesProps = {
  required_access_code?: boolean;
  division_required?: boolean;
};
export type HandleSetFieldValueValueProps = (
  key: KeyOfAddRepresentativesForm,
  value: SetFieldValueValueProps,
  optionalValues?: OptionalValuesProps,
) => void;
